module.exports = __webpack_public_path__ + "media/images/forest-3388a77f4647647bcaa27d61ac2dc56a.jpg";